import { Grid,Avatar, Typography} from "@material-ui/core";
import {FOOTER_TEXTS, FOOTER_UTILS, isDebugMode} from '../../utility';
import { useLocation } from 'react-router-dom';
import DebugPanel from './debugPanel.js';
import ManualLoginPanel from './manualLoginPanel';
function Footer(){
    const location = useLocation();
    return(
        <Grid container xs="12" md="12" direction="row" alignItems="center" justify="center" spacing={1}  style={{position:"sticky", bottom: '0' ,zIndex:999,backgroundColor: '#F9F9FA',borderTopColor: '#EAEAE9',borderTopStyle: 'solid',backgroundColor:'#F9F9FA',padding: (window.window.isClassicEditor)? '0rem 0rem 1rem 1rem' : 'unset'}}>
            <Grid item direction="row" xs="12">
                <a href={FOOTER_UTILS.TOPIC_LOGO_URL_LINK}  target="_blank">
                    <Avatar variant="square" src={FOOTER_UTILS.TOPIC_LOGO_LINK} style={{width:85,display:'inline-block',float:'left'}}/>
                </a>
                <a target="_blank" href={FOOTER_UTILS.WORDPRESS_RELEASE_LINK} style={{fontSize:'0.6rem', textDecoration:"underline"}}>{FOOTER_TEXTS.VERSION_NUMBER}</a>
                {isDebugMode() && <DebugPanel />}
                <a href={FOOTER_UTILS.HELP_TXT_LINK} target="_blank">
                    <Typography variant="caption" style={{display:'inline-block',margin:"0.5rem",float:'right'}}>{FOOTER_TEXTS.HELP_TXT}</Typography>
                </a>
                <ManualLoginPanel/>
            </Grid>
        </Grid>
    );

}

export default Footer;